
export enum ApiError
{
	None = "None",

	Unknown = "Unknown",

	/* Backend errors */

	BadRequest = "BadRequest",
	MissingParameter = "MissingParameter",
	InvalidParameter = "InvalidParameter",
	InputCouldNotBeParsed = "InputCouldNotBeParsed",

	InvalidCredentials = "InvalidCredentials",
	NoAccessToken = "NoAccessToken",
	InvalidAccessToken = "InvalidAccessToken",
	NoClientId = "NoClientId",
	InvalidClientId = "InvalidClientId",
	InvalidClientSecret = "InvalidClientSecret",

	ResourceCouldNotBeFound = "ResourceCouldNotBeFound",
	ResourceCouldNotBeCreated = "ResourceCouldNotBeCreated",
	ResourceCouldNotBeModified = "ResourceCouldNotBeModified",
	ResourceCouldNotBeDeleted = "ResourceCouldNotBeDeleted",

	UserNotAuthorizedToAccessResource = "UserNotAuthorizedToAccessResource",
	UserNotAuthorizedToCreateResource = "UserNotAuthorizedToCreateResource",
	UserNotAuthorizedToModifyResource = "UserNotAuthorizedToModifyResource",
	UserNotAuthorizedToDeleteResource = "UserNotAuthorizedToDeleteResource",

	EmailAddressInUse = "EmailAddressInUse",
	EmailAddressNotValid = "EmailAddressNotValid",
	PasswordDoesNotMeetRequirements = "PasswordDoesNotMeetRequirements",

	ReservationTimeIsNotAvailable = "ReservationTimeIsNotAvailable",
	ReservationTimeIsNotValid = "ReservationTimeIsNotValid",
	ReservationCannotBeCancelled = "ReservationCannotBeCancelled",

	/* Client errors */
	
	NoUserBusinessIdExists = "NoUserBusinessIdExists",
	ResponseCouldNotBeParsed = "ResponseCouldNotBeParsed"
}

function parseError(json: any): ApiError
{
	if (typeof json === 'object' && typeof json['error'] === 'string')
	{
		const input: string = json['error'];

		try
		{
			let typedApiErrorStr = input as keyof typeof ApiError;
			return ApiError[typedApiErrorStr];
		}
		catch (ex)
		{
			console.log("parseApiError() failed to parse input to ApiErrorType");
		}
	}

	return ApiError.Unknown;
}

export function returnApiError(json: any): Promise<never>
{
	console.log(json);

	return Promise.reject(parseError(json));
}
